/** Web mirror of packages/domain/src/premium.ts — keep in sync. */
export type PremiumFeatureKey =
  | 'fuel_tracking'
  | 'maintenance_ai_entry'
  | 'maintenance_schedules'
  | 'maintenance_reports'
  | 'maintenance_documents'
  | 'edit_with_ai'
  | 'vehicle_record';

export const PREMIUM_FEATURE_LABELS: Record<PremiumFeatureKey, string> = {
  fuel_tracking: 'Fuel tracking',
  maintenance_ai_entry: 'Smart maintenance entry',
  maintenance_schedules: 'Advanced maintenance schedules',
  maintenance_reports: 'Maintenance reports',
  maintenance_documents: 'Private receipt storage',
  edit_with_ai: 'Edit with AI',
  vehicle_record: 'Bilt:Spec Vehicle Record',
};
